<template>
  <div class="">
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg('Filters') }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="resetFilters">
                <feather-icon icon="XIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>

          <b-col cols="12" md="3" class="mb-md-0">
            <label>{{ msg('Client') }}</label>
            <b-form-input
                :debounce="500"
                v-model="filter.like.fullName"
                class="d-inline-block mr-1"
            />
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0">
            <label>{{ msg('Status') }}</label>
            <v-select
                :dir="isRTL ? 'rtl' : 'ltr'"
                v-model="filter.in.status"
                :options="orderStatus"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
                multiple
            />
          </b-col>
          <b-col cols="12" md="3" class="mb-md-0">
            <label>{{ msg("Contract") }} {{ msg('Id') }}</label>
            <b-form-input
                v-model="filter.like.dynamicId"
                class="d-inline-block mr-1"
            />
          </b-col>

          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Platform')" label-for="realEstate-branch">
              <v-select
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  v-model="filter.eq.platform"
                  :options="[
                      {value:'Booking',label:('Booking')},
                      {value:'Airbnb',label:('Airbnb')},
                      {value:'Treasure Home',label:('Treasure Home')},
                      {value:'Expedia',label:('Expedia')},
                      {value:'Vrbo',label:('Vrbo')},
                      {value:'Agoda',label:('Agoda')},
                      {value:null,label:('All')}
                      ]"
                  :clearable="false"

                  label="label"
                  :reduce="(status) => status.value"
                  class="w-100"

              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3" class="mt-1">

            <b-form-group :label="msg('Real estate')" label-for="realEstate-branch">
              <real-estate-picker v-model="filter.eq.dynamicId2"/>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="3" class="mt-1">
            <label>{{ msg('Invoice#') }}</label>
            <b-form-input
                :debounce="500"
                v-model="filter.like.invoiceNumber"
                class="d-inline-block mr-1"
            />
          </b-col>

          <!-- Field: Country -->
          <b-col cols="12" md="3" class="mt-1">
            <b-form-group :label="msg('Country')" label-for="ountry">
              <v-select
                  v-bind:dir="isRTL ? 'rtl' : 'ltr'"
                  v-model="filter.like.country"
                  :options="allCountries"
                  class="w-100"
                  label="name"
                  :reduce="(lang) => lang.iso"
                  autocomplete="on"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mt-1">
            <b-form-group :label="msg('checkinrange')" label-for="realEstate-branch">

              <calendar-picker-range v-model="filter.eq.datesRange"/>
            </b-form-group>
          </b-col>


          <b-col cols="12" md="3">
            <div class="mt-2">
              <b-form-group :description="msg('Local tax paid') ">

                <b-form-checkbox
                    v-model="filter.eq.paidTax"
                    name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>

            </div>

          </b-col>

        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <div class="card-header" style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Invoices') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="()=>$refs['invoiceTable'].refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>
      <!--Card Content-->
      <b-card-body>
        <div class="">
          <!-- Table toolbar: page size · selection actions · export -->
          <div class="inv-toolbar">
            <div class="inv-toolbar__left">
              <span class="inv-toolbar__label">{{ msg('Show') }}</span>
              <v-select
                  v-model="amountPerPage"
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  :options="[10, 25, 50, 100,500,1000]"
                  :clearable="false"
                  class="per-page-selector inv-toolbar__select"
                  @input="(amount)=>$refs['invoiceTable'].updatePageAmount(amount)"
              />
              <span class="inv-toolbar__label">{{ msg('entries') }}</span>
            </div>

            <div class="inv-toolbar__right">
              <span class="inv-toolbar__selected" :class="{'inv-toolbar__selected--on': selectedCount > 0}">
                <i class="fas fa-check-square mr-25"/>{{ selectedCount }} {{ msg('selected') }}
              </span>
              <b-button variant="outline-secondary" size="sm" class="inv-toolbar__btn" :disabled="selectedCount < 1"
                        v-b-tooltip.hover :title="selectedCount < 1 ? msg('selectinvoicesfirst') : ''" @click="makeMonetaryVisible">
                <i class="far fa-eye mr-25"/>{{ msg('visiblemonetarybycheckoutdate') }}
              </b-button>
              <b-button variant="outline-primary" size="sm" class="inv-toolbar__btn" :disabled="selectedCount < 1"
                        v-b-tooltip.hover :title="selectedCount < 1 ? msg('selectinvoicesfirst') : ''" @click="openTotalLocalTaxConfirmation">
                <i class="fas fa-coins mr-25"/>{{ msg('payselectedtax') }}
              </b-button>
              <span class="inv-toolbar__sep"/>
              <b-dropdown variant="success" size="sm" right boundary="window" menu-class="inv-toolbar__menu" toggle-class="inv-toolbar__excel">
                <template #button-content><i class="fas fa-file-excel mr-50"/>{{ msg('invoiceExport.button') }}</template>
                <b-dropdown-item @click="$refs.exportModal.open('invoices')"><i class="fas fa-file-invoice mr-50"/>{{ msg('invoiceExport.invoices') }}</b-dropdown-item>
                <b-dropdown-item @click="$refs.exportModal.open('regions')"><i class="fas fa-earth-europe mr-50"/>{{ msg('invoiceExport.regions') }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <invoices-table ref="invoiceTable" v-bind:filter="filter" @custom-event-name="handleDataFromChild"/>

          <b-modal :id="taxTotalModal.id" :title="msg('Confirmation')" @ok="payTotalTax"
                   ok-variant="danger" :cancel-title="msg('cancel')" @hide="resettotalTaxModal">
            <p class="my-4">{{ msg('confirmtaxpayment') }}</p>
          </b-modal>
        </div>
      </b-card-body>
    </b-card>
    <invoice-export-modal ref="exportModal" :buildings="buildings"/>

  </div>

</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {mapActions, mapGetters} from 'vuex'
import InvoicesTable from '@/views/monetary/invoice/invoices-table'
import CalendarPickerRange from "@/components/widgets/calendar/calendarPickerRange";
import InvoiceExportModal from "@/components/modals/monetary/InvoiceExportModal.vue";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker";
import mixinFilter from "@/mixins/mixinFilter";

const invoiceFilter = () => ({
  fromDate: null,
  untilDate: null,
  in: {status: ["PAID"]},
  like: {id: "", amount: ""},
  gte: {creationDate: null,},
  eq: {},

  lte: {creationDate: null}
});

const buildingFilter = () => ({
  like: {},
  eq: {},
  lte: {},
  gte: {},
  in: {}
})

export default {
  components: {
    InvoiceExportModal,
    /* eslint-disable-next-line vue/no-unused-components */
    InvoicesTable, CalendarPickerRange, RealEstatePicker, BCardActions
  },
  mixins: [mixinFilter],
  name: 'invoices',
  data: () => ({
    datesRange: null,
    datesRangeExcel: null,
    filter: null,
    countryOptions: [
      { value: "AT", text: "Austria" },
      { value: "DE", text: "Germany" },
      { value: "FR", text: "France" },
      { value: "US", text: "United States" },
      { value: "IL", text: "Israel" },
      { value: "CH", text: "Switzerland" },
      { value: "GB", text: "United Kingdom" },
      // Add more as needed...
    ],
    buildingFilter: buildingFilter(),
    selectedMonetaryIds: null,
    savingContract: false,
    treasureContractMulti: false,
    salesOverview: false,
    regionOverview: false,
    buildings: [],
    buildingExcel: null,
    generatingExcel: null,
    generatingRegionExcel: null,
    excelPlatform: null,
    taxTotalModal: {
      id: 'tax-total-modal',
      title: '',
      content: ''
    },

    amountPerPage: 10,
    items: [],
  }),
  watch: {
    filter: {
      deep: true,
      handler() {
      }
    },
  },

  created() {
    this.filter = this.loadCachedFilters(invoiceFilter);

    let $this = this;
    this.getAllBuildings({
      page: 1,
      amount: 9999,
      filter: $this.buildingFilter,
      sortcolumn: 'updatedDate',
      sortby: 'desc',
    }).then(this.onBuildingsRetrieve, (error) => $this.error = error)
  },
  computed: {
    selectedCount() {
      return this.selectedMonetaryIds == null ? 0 : this.selectedMonetaryIds.length
    },
    ...mapGetters('order', ['allMonetaryStatus']),
    ...mapGetters('data', ['getAllCountries', 'getAllLanguage']),

    allCountries() {
      return Object.values(this.getAllCountries)
    },
    orderStatus() {
      return this.allMonetaryStatus.map(status => ({
        value: status.value,
        text: this.msg(status.text).toUpperCase()
      }))
    },
    creationDate: {
      get() {
        return {start: this.filter.fromDate, end: this.filter.untilDate}
      },
      set(v) {
        this.filter.fromDate = v.start;
        this.filter.untilDate = v.end;
      }
    }
  },
  methods: {
    ...mapActions('monetary', ['payMultiMonetaryTax', 'makeMultiMonetaryVisible', 'downloadMonetaryExcel']),
    ...mapActions('building', ['getAllBuildings']),
    getFlagEmoji(isoCode) {
      return isoCode
          ? isoCode
              .toUpperCase()
              .replace(/./g, char =>
                  String.fromCodePoint(127397 + char.charCodeAt())
              )
          : '';
    },
    resettotalTaxModal() {
      this.$root.$emit('bv::hide::modal', this.taxTotalModal.id)
    },
    onSubmitted(ans) {
      if (ans.status) {
        this.refresh()

        this.dialogs.treasureContract = false;
        this.dialogs.treasureContractMulti = false;

      }

    },
    submitContract() {
      this.savingContract = true;
      this.$root.$emit('crm::submitContract')
    },
    resetButton() {
      this.savingContract = false;
    },
    payTotalTax() {
      let msghis = this
      this.payMultiMonetaryTax({ids: this.selectedMonetaryIds})
          .then(() => {
                if (msghis.$refs.invoiceTable) {
                  msghis.$refs.invoiceTable.refresh(); // Call the child component's refresh method
                }

              }
          )
    },
    openSalesOverview() {
      let $this = this;

      this.salesOverview = true
    },
    openRegionOverview() {
      let $this = this;

      this.regionOverview = true
    },
    onBuildingsRetrieve(data) {
      this.buildings = data["Buildings"];
    },
    openTotalLocalTaxConfirmation() {
      this.$root.$emit('bv::show::modal', this.taxTotalModal.id)
    },
    makeMonetaryVisible() {
      let msghis = this
      this.makeMultiMonetaryVisible()
          .then(() => {
                if (msghis.$refs.invoiceTable) {
                  msghis.$refs.invoiceTable.refresh(); // Call the child component's refresh method
                }

              }
          )
    },
    handleDataFromChild(data) {
      console.log("data: ", data);
      this.selectedMonetaryIds = data['key']
          .filter(invoice => invoice.paidTax === null || !invoice.paidTax)
          .map(invoice => invoice.id);

     /* const totalAmount = data['key']
          .filter(invoice => (invoice.paidTax === null || !invoice.paidTax) && invoice.system_comment == null)
          .reduce((sum, invoice) => sum + invoice.amount, 0);

      console.log("totalAmount: ", totalAmount);
      this.totalAmount = totalAmount;
      this.totalTax = totalAmount * 0.025237;
      this.tax = totalAmount - (totalAmount / 1.1);*/
    },
    convertToEURO(someNumber) {
      return new Intl.NumberFormat("de-AT", {
        style: "currency",
        currency: "EUR",
      }).format(someNumber);
    },
    rangeToStr(dateRange) {
      if (dateRange.start == null)
        return "";
      if (dateRange.end == null)
        return this.$moment(dateRange.start, 'YYYY-MM-DD').format('DD/MM/YYYY');
      return this.$moment(dateRange.start, 'YYYY-MM-DD').format('DD/MM/YYYY') + " - " + this.$moment(dateRange.end, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }
}
</script>

<style scoped>
/* toolbar above the table */
.inv-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 12px; }
.inv-toolbar__left { display: inline-flex; align-items: center; gap: 8px; }
.inv-toolbar__label { font-size: .8rem; color: #64748b; font-weight: 600; white-space: nowrap; }
.inv-toolbar__select { min-width: 92px; }
.inv-toolbar__right { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-left: auto; }
.inv-toolbar__selected {
  display: inline-flex; align-items: center; font-size: .7rem; font-weight: 800; text-transform: uppercase; letter-spacing: .04em;
  padding: 4px 10px; border-radius: 999px; background: rgba(100,116,139,.12); color: #94a3b8; white-space: nowrap;
  &--on { background: rgba(115,103,240,.14); color: #7367f0; }
}
.inv-toolbar__btn { white-space: nowrap; }
.inv-toolbar__sep { width: 1px; height: 24px; background: rgba(15,23,42,.1); }
.inv-toolbar__excel { font-weight: 700; background: #1d6f42 !important; border-color: #1d6f42 !important; box-shadow: 0 4px 10px rgba(0,100,0,.25); }
.inv-toolbar__excel:hover { background: #218c54 !important; border-color: #218c54 !important; }
/* the menu must float above the table and never be clipped by the card */
.inv-toolbar .dropdown { position: relative; }
.inv-toolbar__menu { z-index: 1060 !important; min-width: 220px; border-radius: 10px; box-shadow: 0 12px 30px rgba(15,23,42,.18); }
.inv-toolbar__menu .dropdown-item { padding: 8px 14px; font-size: .84rem; }
.dark-layout .inv-toolbar__label { color: #94a3b8; }
.dark-layout .inv-toolbar__sep { background: rgba(255,255,255,.12); }

.excel-button {
  background-color: #1D6F42 !important; /* Excel green */
  border-color: #1D6F42 !important;
  color: white !important;
  font-weight: bold;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 100, 0, 0.25);
  transition: all 0.2s ease;
}

.excel-button:hover {
  background-color: #218C54 !important;
  transform: translateY(-1px);
}

</style>
